export default __webpack_public_path__ + "static/media/slide2.665eed25.jpg";